import axios from "axios";
import Cookies from "js-cookie";
import { decryptData } from "../utils/helpers";

const instance = axios.create({
  baseURL: process.env.REACT_APP_STG_BASE_API_URL,
  // baseURL: "http://localhost:3010/admin",
  headers: { "Content-Type": "application/json" },
});

// =========================
// REQUEST INTERCEPTOR
// =========================
instance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    const sc_id = Cookies.get("sc_id") || "0";
    const adminCookie = Cookies.get("admin_enc");
    const admin_enc = adminCookie ? decryptData(adminCookie) : null;
    const expiresIn = admin_enc?.expiresIn;

    if (expiresIn && Date.now() > Number(expiresIn)) {
      Cookies.remove("token");
      Cookies.remove("admin_enc");
      Cookies.remove("sc_id");

      window.location.href = "/";
      return Promise.reject("Session expired");
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers["sc_id"] = sc_id;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// =========================
// RESPONSE INTERCEPTOR
// =========================
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default instance;
